import React from 'react';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import SellerOtherItems from './components/SellerOtherItems';

import { TListingClient } from 'types/TListing';

export type TSellerOtherItemsProps = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
};

const SellerOtherItemsApp = ({ appState, environment }: TSellerOtherItemsProps) => {
  const { listing } = appState;

  return (
    <EnvironmentProvider value={environment}>
      <SellerOtherItems listing={listing} />
    </EnvironmentProvider>
  );
};

export default SellerOtherItemsApp;
